import { SYSBaseElement, html } from "../../../../_ovlclient/src"
import { PermissionHas } from "../../../../_ovlclient/src/global/globalapi"
import {
  DialogOk,
  DialogOpen,
} from "../../../../_ovlclient/src/library/dialog/dialogapi"
import { TableRefresh } from "../../../../_ovlclient/src/library/table/tableapi"
import { T } from "../../../../_ovlclient/src/textapi"
import { Data } from "../../../src/dataapi"

export class CompSYSUserAdministrationSettings extends SYSBaseElement {
  handleUserAdministrationUser = async (e: Event) => {
    await TableRefresh("SYSUserAdministration_Role", { suppressBusySnack: true })
    await TableRefresh("SYSUserAdministration_User")
    DialogOpen("SYSUserAdministration_User")
  }
  handleUserAdministrationCompany = async (e: Event) => {
    await TableRefresh("SYSUserAdministration_Company")
    DialogOpen("SYSUserAdministration_Company")
  }

  handleUserAdministrationRole = async (e: Event) => {
    await TableRefresh("SYSUserAdministration_Role")
    DialogOpen("SYSUserAdministration_Role")
  }

  handleActorTOTP = async (e: Event) => {
    var res = await Data("users/pptotp")
    DialogOk(
      html`<img src="${res.data.SetupQrCodeImageUrl}" />
        <p>${res.data.SetupManualCode}</p>`,
      { title: "Admin Actor TOTP Setup" }
    )
  }

  async getUI() {
    let userState = this.state.ovl.user
    if (userState.isActor) {
      return null
    }
    let userAdministration
    let roles
    let users
    let companies

    let ActorTOTPRegisterButton

    if (userState.role === "Admin" && this.state.ovl.app.actorTOTP) {
      ActorTOTPRegisterButton = html`
        <button
          id="ua_handlepassepartouttotp"
          title="Admin Actor TOTP Setup"
          class="fd-button fd-button--menu"
          @click=${(e) => {
            this.handleActorTOTP(e)
          }}
        >
          Actor TOTP &nbsp;
          <i class="sap-icon--overflow"></i>
        </button>
      `
    }

    if (PermissionHas("SYSRA")) {
      roles = html`
        <button
          id="ua_handlerole"
          class="fd-button fd-button--menu"
          @click=${(e) => this.handleUserAdministrationRole(e)}
        >
          <span class="fd-button__text"
            >${T("SYSUserAdministrationRoleTitle")}</span
          >
          <i class="sap-icon--overflow"></i>
        </button>
      `
    }
    if (PermissionHas("SYSUA")) {
      users = html`
        <button
          id="ua_handleuser"
          class="fd-button fd-button--menu"
          @click=${(e) => this.handleUserAdministrationUser(e)}
        >
          <span class="fd-button__text"
            >${T("SYSUserAdministrationUserTitle")}</span
          >
          <i class="sap-icon--overflow"></i>
        </button>
      `
    }
    if (PermissionHas("SYSCA")) {
      companies = html`
        <button
          id="ua_handlecompany"
          class="fd-button fd-button--menu"
          @click=${(e) => this.handleUserAdministrationCompany(e)}
        >
          <span class="fd-button__text"
            >${T("SYSUserAdministrationCompanyTitle")}</span
          >
          <i class="sap-icon--overflow"></i>
        </button>
      `
    }

    if (roles !== undefined || users !== undefined || companies !== undefined) {
      userAdministration = html`<div class="fd-layout-panel">
        <div class="fd-layout-panel__header">
          <div class="fd-layout-panel__head">
            <h3>
              ${T("SYSUserAdministrationTitle")}
            </h3>
          </div>
        </div>

        <div class="fd-layout-panel__body">
          <div class="sysuseradministration__buttons">
            ${users} ${roles} ${companies} ${ActorTOTPRegisterButton}
          </div>
        </div>
      </div> `
    }
    return userAdministration
  }
}
